import { useEffect } from 'react'
import AppleIcon from '@/assets/icons/apple.svg?react'
import GooglePlayIcon from '@/assets/icons/googlePlay.svg?react'
import BackArrowIcon from '@/assets/icons/caretLeft.svg?react'
import { useNavigate } from 'react-router-dom'
import { eventTracker } from '@/config/trackingFunctions'
import { TRACKING_TYPES } from '@/constants/TrackingConstants'

export const SignUpMobile = () => {
  const navigate = useNavigate()

  useEffect(() => {
    eventTracker(TRACKING_TYPES.MOBILE_SIGN_UP_SPLASH)
  }, [])

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleAppStoreClick = () => {
    eventTracker(TRACKING_TYPES.DOWNLOAD_APPLE_APP)
  }

  const handlePlayStoreClick = () => {
    eventTracker(TRACKING_TYPES.DOWNLOAD_ANDROID_APP)
  }

  return (
    <div className="w-full font-sans bg-blue-600 flex flex-col min-h-screen">
      {/* Blue Header Area */}
      <div className="flex-shrink-0 h-24 p-4">
        <button
          onClick={handleGoBack}
          className="w-9 h-9 bg-black bg-opacity-20 rounded-full flex items-center justify-center text-white"
          aria-label="Go back"
        >
          <BackArrowIcon className="w-5 h-5" />
        </button>
      </div>

      {/* Main Content Card */}
      <main className="flex-1 bg-white rounded-t-2xl px-6 pt-2 pb-8 flex flex-col">
        {/* Logo pulled up into the header */}
        <div className="flex justify-center">
          <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center -mt-12 border-4 border-white shadow-md">
            <span className="text-white text-4xl font-bold">D</span>
          </div>
        </div>

        <div className="text-center mt-4">
          <h1 className="text-3xl font-bold text-gray-900 mb-3">Welcome to DUPR!</h1>
          <p className="text-gray-600 text-base leading-relaxed px-4 mb-8">
            We look forward to you joining the DUPR community! Please download the DUPR app to sign up.
          </p>
        </div>

        <div className="w-full max-w-sm mx-auto space-y-4">
          <a
            onClick={handleAppStoreClick}
            href="https://apps.apple.com/us/app/dupr/id1567932355"
            className="w-full bg-black text-white rounded-full p-3 flex items-center justify-center transition-opacity hover:opacity-90"
          >
            <div className="-ml-4 flex items-center">
              <AppleIcon className="w-6 h-6 mr-3" />
              <div className="text-left">
                <p className="text-xs leading-none">Download on the</p>
                <p className="text-xl font-semibold leading-tight">App Store</p>
              </div>
            </div>
          </a>

          <a
            onClick={handlePlayStoreClick}
            href="https://play.google.com/store/apps/details?id=gg.dupr"
            className="w-full bg-green-500 text-white rounded-full p-3 flex items-center justify-center transition-opacity hover:opacity-90"
          >
            <GooglePlayIcon className="w-5 h-5 mr-3" />
            <div className="text-left">
              <p className="text-xs leading-none">Get it on</p>
              <p className="text-xl font-semibold leading-tight">Google Play</p>
            </div>
          </a>
        </div>

        {/* Spacer to push content to top and bottom */}
        <div className="flex-grow"></div>

        <p className="text-gray-500 text-sm text-center">Join millions of players tracking their pickleball progress</p>
      </main>
    </div>
  )
}
